import React, { FunctionComponent, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { find } from 'ramda';
import { IBindingCallback1, IBindingAction } from '../../../../common/models/callback';
import { IAppState } from '../../../../common/models/store/IAppState';
import { setRoleRoutine } from '../../routines';
import { IContact } from '../../../../common/models/contact/IContact';
import { getColumns } from './utils';
import Table from '../../../../components/Table';
import { ISelectedRole } from '../../../../common/models/contact/ISelectedRole';
import CustomPopover from '../../../../components/CustomPopover';
import { IPopoverChild } from '../../../../common/models/common/IPopoverChild';
import Icon from '../../../../components/Icon';
import styles from './styles.module.scss';
import ChangePositionModal from '../ChangePositionModal';
import TextOverflowTooltip from '../../../../components/TextOverflowTooltip';

interface IProps {
  contact: IContact;
  selectedRole: ISelectedRole;
  setRole: IBindingCallback1<ISelectedRole>;
}

const CandidateDropdown: FunctionComponent<IProps> = ({ contact, selectedRole, setRole }) => {
  const [attachCandidateId, setAttachCandidateId] = useState<undefined | string>();

  const onSelect = (id: string, hidePopover?: IBindingAction) => {
    if (selectedRole.candidateId !== id) {
      setRole({ ...selectedRole, candidateId: id });
    }
    if (hidePopover) {
      hidePopover();
    }
  };

  const { candidates } = contact;
  const selected = find(row => row.id === selectedRole.candidateId, candidates);

  const displayLabel = () => (selected && selected.positionName
    ? selected.positionName
    : <span className="font-italic mr-1"><FormattedMessage id="none" defaultMessage="None" /></span>);

  const Trigger = () => (
    <div className={`popup-trigger ${styles.dropdownTrigger}`}>
      <TextOverflowTooltip content={displayLabel()} width={210}>
        {displayLabel()}
      </TextOverflowTooltip>
      <Icon icon="chevronDown" className="popup-chevron ml-2" />
    </div>
  );

  const getTableHeight = () => (candidates.length > 5
    ? 350
    : candidates.length * 55 + 45);

  const DropdownTable = ({ hidePopover }: IPopoverChild) => (contact ? (
    <div style={{ height: getTableHeight() }}>
      <Table
        className={`table-blue-focus ${styles.table}`}
        config={{
          data: { items: candidates, total: candidates.length },
          columns: getColumns(setAttachCandidateId),
          rowIndent: 0,
          loading: !candidates.length,
          focusable: true,
          defaultFocused: selected,
          onRowClicked: ({ id }) => onSelect(id, hidePopover)
        }}
      />
    </div>
  ) : <></>);

  return (
    <div className="popup-wrapper">
      <ChangePositionModal
        isShown={Boolean(attachCandidateId)}
        attachCandidateId={attachCandidateId}
        onHide={() => setAttachCandidateId(undefined)}
      />
      <CustomPopover
        placement="bottom-start"
        rootClose
        trigger={<Trigger />}
        popoverClassName={styles.dropdownPopover}
      >
        <DropdownTable />
      </CustomPopover>
    </div>
  );
};

const mapStateToProps = ({
  contactProfile: {
    contact: {
      contact,
      role,
      contactId,
      candidateId
    }
  }
}: IAppState) => ({ contact, selectedRole: { role, candidateId, contactId } });

const mapDispachToProps = {
  setRole: setRoleRoutine
};

export default connect(mapStateToProps, mapDispachToProps)(CandidateDropdown);
